import { render, staticRenderFns } from "./add-room1.vue?vue&type=template&id=131b2960&scoped=true&"
import script from "./add-room1.js?vue&type=script&lang=js&"
export * from "./add-room1.js?vue&type=script&lang=js&"
import style0 from "./add-room1.css?vue&type=style&index=0&id=131b2960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131b2960",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
